import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LandingPageSummary } from '../../models/cms-models';

@Component({
  selector: 'cms-landing-page-list',
  imports: [CommonModule],
  templateUrl: './landing-page-list.html',
  styleUrl: './landing-page-list.css',
})
export class LandingPageListComponent {
  @Input() landingPages: LandingPageSummary[] = [];
  @Input() activeFilters: string[] = [];
  @Input() busy = false;
  @Output() createRequested = new EventEmitter<void>();
  @Output() importRequested = new EventEmitter<void>();
  @Output() landingPageOpened = new EventEmitter<string>();
  @Output() filterToggled = new EventEmitter<string>();
  @Output() clearFiltersRequested = new EventEmitter<void>();

  isFilterActive(tag: string): boolean {
    return this.activeFilters.includes(tag);
  }
}
